import createAppSlice from 'app/createAppSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import { IEnrollmentSlice } from './types';

const initialState: IEnrollmentSlice = {
  useCode: null,
  token: null,
  account: {
    userName: null,
    password: null,
  },
  offer: {
    planName: null,
    termName: null,
    termDescription: null,
    groupCode: null,
  },
};

const enrollmentSlice = createAppSlice({
  name: 'enrollment',
  initialState,
  reducers: {
    setUseCode: (state, action: PayloadAction<string>) => {
      state.useCode = action.payload;
    },
    setAccount: (state, action: PayloadAction<IEnrollmentSlice['account']>) => {
      state.account = action.payload;
    },
    setOfferInfo: (state, action: PayloadAction<IEnrollmentSlice['offer']>) => {
      state.offer = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    resetEnrollment: () => {
      return initialState;
    },
  },
});

export const {
  setUseCode,
  setAccount,
  setOfferInfo,
  setToken,
  resetEnrollment,
} = enrollmentSlice.actions;
export default enrollmentSlice.reducer;
